<template>
    <b-overlay :show="showOverlay" no-center class="d-flex flex-column h-100 w-100" z-index="0">
        <template #overlay>
            <Welcome :DisplayBrand="false" :Loading="true" :Variant="Variant">
                <template v-slot:MiscContent>
                    <h4 class="text-center">{{ OverlayMessage }}</h4>
                </template>
            </Welcome>
        </template>
        <b-container fluid class="d-flex flex-column mh-100 h-100 no-gutters py-0 w-100 overflow-auto"
            :class="!hasReport ? 'justify-content-center' : ''" :style="generateVariantStyle(Variant)">
            <b-row class="w-75 no-gutters py-2 justify-content-center align-self-center">
                <b-card v-if="this.reportList !== undefined && this.hasReport" class="p-1 w-75 border"
                    body-class="d-flex flex-column align-self-center w-100 p-0 my-0 rounded shadow-sm ">
                    <b-card-header header-tag="header" class="text-center font-weight-bold py-1 mx-0 w-100">
                        <b-row align-v="center">
                            <b-col align-v="center">
                                <div class="d-flex justify-content-center">
                                        <!-- "Nom du rapport" -->
                                    <div class="p-2 pr-3">{{ $t('ReportName') }} : </div>
                                    <b-form-select v-model="selectId" value-field="Id" text-field="Label" plain
                                        class="w-50 rounded" :class="'border-' + Variant">
                                        <b-form-select-option v-for="report in reportList" :key="report.Id"
                                            :value="report.Id">
                                            {{ report.Name }}
                                        </b-form-select-option>
                                    </b-form-select>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card-header>
                   <ReportParameter :ReportParameters="reports?.find(u => u.ReportId === selectId)?.ReportParameters"/>
                    <b-card-footer>
                        <!-- Generate -> "Générer" -->
                        <div class="d-flex justify-content-center">
                            <b-button style="width: 15%" pill @click="generateReport()">{{ $t('Generate') }}</b-button>
                        </div>
                    </b-card-footer>
                </b-card>
                <b-card v-else-if="!hasReport" class="d-flex flex-column justify-content-center align-items-center"
                    style="opacity: 0.9">
                    <b-card-title>
                        <b-row>
                             <!-- NoReportAvailable' -> "Aucun bilan disponible sur ce noeud" -->
                            <b-col class="pt-0 pb-2 h1 text-center">
                                <div class="font-weight-bold">{{ $t('NoReportAvailable') }}</div>
                            </b-col>
                        </b-row>
                    </b-card-title>
                    <b-card-text>
                        <b-row class="text-center">
                            <b-col>
                                <!-- "Veuillez sélectionner un autre noeud dans l'arborescence ou contacter votre administrateur" -->
                                <h5><span class="text-gray-dark">{{ $t('SelectOtherNode') }}</span></h5>
                            </b-col>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-row>
        </b-container>
    </b-overlay>
</template>

<script lang="ts">
    import { Prop, Watch, Vue, Inject } from 'vue-property-decorator';
    import Component, { mixins } from 'vue-class-component';
    import { ThemeUtils, LinkUtils } from "@/components/commons/Utils";
    import { API_URL } from "@/App.settings";
    import axios from 'axios';
    import Dictionary from '@/types/Dictionary';;
    import ParametersItems from './ParametersItems.vue';
    import Report from './Report';
    import ReportList from './ReportList';
    import Checks from './Checks';
    import DownloadingStore from '@/store/DownloadingStore';
    import Download from '@/types/Download';
    import DownloadStateEnum from '@/enums/DownloadStateEnum';
    import Welcome from '@/components/commons/Welcome.vue';
    import ReportParameter from "./ReportParameter.vue";
    import locales from "./locales/Exploitation.json";
    import GridPanelField from './Class/GridPanelField';
    import TreeNode from '@/types/TreeNode';
    import IFeature from '@/interfaces/IFeature';

    /**
     * Report/Exploitation
     */
    @Component({
        components: {
            ParametersItems,
            DownloadingStore,
            Welcome,
            ReportParameter
        },
        i18n: {messages: locales}
    })
	export default class Exploitation extends mixins(ThemeUtils, LinkUtils) implements IFeature {
        /** Variant de couleur à appliquer sur le composant */
		@Prop({default: () => "secondary"})
		public Variant!: string;

        // LoadingReportList -> Chargement de la liste des rapports
        public showOverlay: boolean = true;
        public OverlayMessage: string = this.$t('LoadingReportList').toString();
        public selectId: string = "";
        public reportList: ReportList[] = []; 
        public reports: Report[] = [];
        public hasReport: boolean = true;

        private singleNode: TreeNode = {} as TreeNode;

        public SetNode(node: TreeNode): Promise<any> {
            return new Promise(async (resolve, reject) => {
                this.singleNode = node;
                this.getReportList();
                resolve('SingleNode affecté !');
            });
        }

        private async getReportList()
        {
            // LoadingReportList -> Chargement de la liste des rapports
            this.reportList = [];
            this.showOverlay = true;
            this.hasReport = true;
            this.OverlayMessage = this.$t('LoadingReportList').toString();

            const args: Dictionary<any> = {};
            args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
            args["NodeId"] = this.singleNode.Id;
            args["NodeType"] = this.singleNode.ObjectType;

            await axios.post<ReportList[]>(API_URL + "ReportExploitation/GetReportList", args).then((response) => {
                this.reportList = response.data;
                if(this.reportList)
                    this.selectId = this.reportList[0].Id.toString();
                else {
                    this.hasReport = false;
                    this.selectId = "";
                    this.showOverlay = false;
                }
            })
        }

        @Watch('selectId')
        private async getReport() {
            if (this.selectId != "") {
                if (this.reports === undefined || this.reports != undefined && this.reports.find(u => u.ReportId === this.selectId) === undefined) {
                    this.showOverlay = true;
                    /** @Todo Revoir la gueule de ce message un peu */
                    this.OverlayMessage = this.reportList.find(u => u.Id === this.selectId).Name;
                    const args: Dictionary<any> = {};
                    args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
                    args["ReportId"] = this.selectId;
                    args["NodeId"] = this.singleNode.Id;

                    try{
                        await axios.post<Report>(API_URL + "ReportExploitation/GetReport", args).then((response) => {
                            // let report: Report = JSON.parse(JSON.stringify(response.data));
                            // console.log("Test : ", response.data)
                            let report: Report = new Report().CreateReport(response.data);
                            // let report: Report = Report.CreateReport(response.data);
                            // console.log("Test Report : ", report instanceof Report)
                            this.reports.push(report);
                    })
                    } catch (e){
                        console.log("Error : ", e)
                    }
                  
                }
                this.showOverlay = false;
            }
        }

        /**
         * Génère le rapport séléctionné
         */
        private async generateReport(){
            let parameters: Dictionary<any> = {};
            let selectedReport: Report = this.reports.find(u => u.ReportId === this.selectId);
            let checksList: Checks[] = JSON.parse(JSON.stringify(selectedReport.ReportParameters.Checks));

            if(selectedReport.ReportParameters.DictionaryParameters != null){
                Object.entries(selectedReport.ReportParameters.DictionaryParameters).forEach(([key, value]) => {
                    parameters[key] = value;
                })
            }

            selectedReport.ReportParameters.FieldSets.forEach(FieldSet => {

                let fieldSetName = "";
                let fieldSetSelected = "";

                if(FieldSet.Name != undefined && FieldSet.Name != "" && FieldSet.CheckboxToggle != null){
                    fieldSetName = FieldSet.Name;
                    fieldSetSelected = JSON.stringify(FieldSet.CheckboxToggle);

                    parameters[fieldSetName] = fieldSetSelected;
                }

                FieldSet.Parameters.forEach(parameter => {

                    if(parameter instanceof GridPanelField){
                        parameter.Selected = null;
                        (parameter as GridPanelField).Options.forEach(x => {
                            if(x.Value.find(z => z.Key === 'Selected' && z.Value === 'true')){
                                if(parameter.Selected === null)
                                    parameter.Selected = x.Key;
                                else  parameter.Selected += ", " + x.Key;
                            }
                        })
                    }

                    let name = parameter.Name;
                    let selected = parameter.Selected;

                    parameters[name] = selected;

                    if(checksList !== null){
                        checksList.forEach(check => {
                            if(fieldSetName != "" && check.Test.includes(fieldSetName))
                                check.Test = check.Test.replaceAll(fieldSetName, parameters[fieldSetName])                        

                            if(check.Test.includes(name))
                                check.Test = check.Test.replaceAll(name, parameters[name])
                        })
                    }
                });
            })

            let isChecks: boolean = true;

            try{
                if(checksList !== null){
                    checksList.forEach(check => {

                        Object.entries(parameters).forEach(([key, value]) => {
                            if(check.Test.includes(key))
                                check.Test = check.Test.replaceAll(key, value)
                        })

                        let checkTest: string = check.Test.replaceAll(" AND ", " && ").replaceAll(" OR ", " || ");

                        let checkSplit: string[] = checkTest.split(" = ");

                        if(checkSplit[0] === '' || checkSplit[1] === '' || eval(checkTest)){
                            throw new Error(check.Message);
                        }
                    })
                }
            } catch (error){

                isChecks = false;
                this.$bvToast.toast(error.message, {
                    autoHideDelay: 3000,
                    title: this.$t('Error').toString(),
                    variant: "danger",
                    solid: false,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            }

            if(isChecks){
                const args: Dictionary<any> = {};
                args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
                args["NodeId"] = this.singleNode.Id;
                args["Parameters"] = parameters;
                args["Id"] = this.selectId;

                let type: string = selectedReport.Type == "Word" ? ".docx" : ".xlsx";

                let index: number = this.$store.getters['DownloadingStore/GetLastIndex'];
                let download: Download = {Index: ++index, Name: selectedReport.Name + '_' + index + type, Type: type, State: DownloadStateEnum.InProgress, Data: "", Direct: false}
                this.$store.dispatch('DownloadingStore/AddDownloading', download);

                // ReportInProgress -> Votre rapport est en cours de génération
                this.showToast(selectedReport.Name, this.$t('ReportInProgress').toString(), 3000, "info", index, DownloadStateEnum.InProgress);

                let debut = performance.now();

                await axios.post(API_URL + "ReportExploitation/DownloadReport", args,  { responseType: 'blob'}).then((response) => {
                    let results: Dictionary<any> = response.data;

                    this.$store.dispatch('DownloadingStore/AddData', {index, data: results});
                    // ReportAvailable -> Votre rapport est disponible !
                    this.showToast(selectedReport.Name, this.$t('ReportAvailable').toString(), 2000, "success", index, DownloadStateEnum.Finished);
                })
                .catch(err => {
                    this.showToast(this.$t('Error').toString(), this.$t('AnErrorOccuredContactAdmin').toString() + err, 5000, "danger", index, DownloadStateEnum.Error);
                })

                let fin = performance.now();
                let totalSeconds = Math.floor((fin - debut) / 1000);
                let minutes = Math.floor(totalSeconds / 60);
                let secondes = totalSeconds % 60;
                console.log(`Temps d'exécution : ${minutes} minutes et ${secondes} secondes`);
            }            
        }

        /**
         * Affiche le message, et change l'état du Download
         * @param title 
         * @param message 
         * @param delay 
         * @param variant 
         * @param index 
         * @param state 
         */
        private showToast(title: string, message: string, delay: number, variant: string, index: number, state: DownloadStateEnum){
            this.$store.dispatch('DownloadingStore/UpdateState', {index, state: state})
            this.$bvToast.toast(message, {
                    autoHideDelay: delay,
                    title: title,
                    variant: variant,
                    solid: false,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
        }
    }
    </script>

    <style scoped>
        :deep(input[type=checkbox]:checked) {
            /** Change la couleur de la checkbox */
            accent-color: var(--Variant) !important;
        }

        :deep(input[type=radio]:checked) {
            /** Change la couleur du bouton radio */
            accent-color: var(--Variant) !important;
        }

        /** Pour que la page active prenne en compte la couleur de Variant */
        :deep(.page-item.active .page-link) {
            background-color: var(--Variant) !important;
        }

        :deep(.page-link:hover) {
            background-color: var(--VariantLight) !important;
        }
    </style>